<div class="container">
  <mat-table [dataSource]="dataSource" class="mat-elevation-z1">
    <ng-container matColumnDef="region">
      <mat-header-cell *matHeaderCellDef>{{groupBy.toUpperCase() | translate}}</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.region }}</mat-cell>
    </ng-container>

    <ng-container *ngFor="let col of displayedColumns.slice(1)" [matColumnDef]="col" >
      <ng-container *ngIf="col !== 'region'">
        <mat-header-cell *matHeaderCellDef>
          {{ formatDate(col) }}
        </mat-header-cell>
      </ng-container>
      <ng-container *ngIf="col !== 'region'">
        <mat-cell *matCellDef="let element">
          {{ element[col] ? (element[col] | number : '1.2-2') : '-' }}
        </mat-cell>
      </ng-container>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
